import { Marionette } from "global/globals"

export var Pixlee = (function(Backbone, Marionette) {
    var App;
    App = new Marionette.Application();
    App.on('before:start', function(options) {
        App.isWidget = true;
        App.config = App.request('set:config:photos:app');
        // currentUser is actually an Account, but lives inside a User model.
        // This should probably be changed at some point...
        App.currentUser = App.request('set:current:user', options.currentUser);
        App.currentAlbum = new App.Entities.Album(options.currentAlbum);
        App.displayOptions = new App.Entities.DisplayOptions(options.display_options);
        App.recipe = new App.Entities.Recipe(options.recipe);
        if (App.currentAlbum.get("campaign")) {
            initializeCookie();
        }
    });

    App.reqres.setHandler('get:photo:url', function(id) {
        return Routes.distillery_photo_path(id);
    });

    App.addRegions({
        widgetsRegion: '#widgets_main_region'
    });
    App.reqres.setHandler('default:region', function() {
        return App.widgetsRegion;
    });

    App.commands.setHandler('register:instance', function(instance, id) {
        if (App.config.environment === 'development') {
            return App.register(instance, id);
        }
    });

    App.reqres.setHandler('concern', function(concern) {
        return App.Concerns[concern];
    });

    App.commands.setHandler('unregister:instance', function(instance, id) {
        if (App.config.environment === 'development') {
            return App.unregister(instance, id);
        }
    });
    App.on('start', function(options) {
        if (Backbone.history) {
            Backbone.history.start();
            if (this.getCurrentRoute() === '') {
                return this.navigate(this.rootRoute, {
                    trigger: true
                });
            }
        }
    });

    return App;
})(Backbone, Marionette);
window.Pixlee = Pixlee;
